import { useNavigate } from "@tanstack/react-router";
import { error404Img } from "../../../assets/index";
import { evaluationDashboardRoute } from "../../../router/routes";
import { Button, Typography } from "../../../components/ui";

const NoPageFound = () => {
  const navigate = useNavigate();

  const backToHome = () => {
    void navigate({ to: evaluationDashboardRoute.to });
  };

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <img
        src={error404Img}
        alt="404 Not Found"
        className="h-auto max-w-[25%]"
      />
      <Typography variant={"h3"} affects={"bold"} className="mt-10">
        PAGE NOT FOUND
      </Typography>
      <Typography className="mb-6 mt-2">
        The resource requested could not be found on server
      </Typography>

      <Button
        type="button"
        variant={"default"}
        size="md"
        onClick={backToHome}
        id="no-page-found-back-to-home-button"
      >
        Back to Home
      </Button>
    </div>
  );
};

export default NoPageFound;
